module.exports = __webpack_public_path__ + "static/media/img19.6d1c3507.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/img19.png
// module id = 128
// module chunks = 0